import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import NavigationComponent from './NavigationComponent';

import {
  FacebookShareButton,
  TwitterShareButton,
  PinterestShareButton
} from 'react-share';

import Ink from 'react-ink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faPinterestP,
  faFacebookF,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';

import { faEnvelope, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import getButtons from '../../helpers/getButtons';
import styles from './extendedMenuStyle';

class ExtendedMenuContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVideoOpenSubMenu: false,
      isMatterportOpenSubMenu: false,
      titleSubMenu: '',
      showMail: false
    };
  }

  openSubMenu = e => {
    this.setState({
      [e.currentTarget.title]: !this.state[e.currentTarget.title]
    });
  };
  render() {
    const {
      tourType,
      tourId,
      buttonsParams,
      gallery,
      video,
      matterport,
      listingsCount,
      shareBtnVisible
    } = this.props;
    const pinterest = this.props.pinterestImage ? (
      <li>
        <PinterestShareButton
          url={window.location.toString()}
          media={this.props.pinterestImage}
          windowWidth={1000}
          windowHeight={730}
        >
          <button className="btn btn-transparent">
            <Ink />
            <FontAwesomeIcon icon={faPinterestP} size="2x" />
          </button>
        </PinterestShareButton>
      </li>
    ) : null;
    const branded = tourType === 'branded';
    const baseUrl = tourType
      ? `/${tourId}/${tourType.charAt(0)}`
      : `/${tourId}`;
    const links = getButtons(
      baseUrl,
      buttonsParams,
      gallery,
      video,
      matterport,
      listingsCount
    );
    return [
      <div className={styles.extendedMenu} style={this.props.styles} key={0}>
        <div className={styles.closeMenu} onClick={this.props.menuHandler}>
          <FontAwesomeIcon icon={faTimesCircle} size="2x" />
        </div>
        <NavigationComponent
          btn={links}
          styles={styles}
          menuHandler={this.props.menuHandler}
          extended={true}
          openSubMenu={this.openSubMenu}
          isVideoOpenSubMenu={this.state.isVideoOpenSubMenu}
          isMatterportOpenSubMenu={this.state.isMatterportOpenSubMenu}
        />
        <hr />
        {shareBtnVisible && (
          <ul className={styles.social}>
            {branded && (
              <li>
                <FacebookShareButton
                  url={window.location.toString()}
                  quote="share to facebook"
                >
                  <button className="btn btn-transparent">
                    <Ink />
                    <FontAwesomeIcon icon={faFacebookF} size="2x" />
                  </button>
                </FacebookShareButton>
              </li>
            )}
            {branded && (
              <li>
                <TwitterShareButton
                  url={window.location.toString()}
                  title="share to twitter"
                >
                  <button className="btn btn-transparent">
                    <Ink />
                    <FontAwesomeIcon icon={faTwitter} size="2x" />
                  </button>
                </TwitterShareButton>
              </li>
            )}
            {branded && pinterest}
            <li>
              <button
                className="btn btn-transparent"
                onClick={this.props.showMailFormClick}
              >
                <Ink />
                <FontAwesomeIcon icon={faEnvelope} size="2x" />
              </button>
            </li>
          </ul>
        )}
        {branded && (
          <div className={styles.contactWrapper}>
            <NavLink
              onClick={this.props.menuHandler}
              to={baseUrl + '/presented'}
              className={styles.contact}
            >
              CONTACT
            </NavLink>
          </div>
        )}
      </div>,
      <div
        onClick={this.props.menuHandler}
        className={styles.menuOverlay}
        key={1}
      />
    ];
  }
}

// MenuContainer.propTypes = {
//     menuOpened: PropTypes.bool,
//     buttonsParams: PropTypes.object.isRequired,
//     video: PropTypes.shape({
//         videos: PropTypes.array,
//         videoType: PropTypes.string
//     }),
//     pathname: PropTypes.string
// };

const mapStateToProps = state => {
  return {
    menuOpened: state.menu.menuOpened,
    buttonsParams: state.menu.buttonsParams,
    video: state.video,
    matterport: state.matterport,
    gallery: state.gallery,
    tourId: state.app.tourId,
    tourType: state.app.tourType,
    pathname: state.router.location.pathname,
    listingsCount: state.listings.listingsCount,
    pinterestImage: state.gallery.images.length
      ? state.gallery.imagesPath + state.gallery.images[0].file_name
      : '',
    shareBtnVisible: state.menu.buttonsParams.visibility.shareBtnVisible
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // menuActions: bindActionCreators(MenuActions, dispatch),
    // modalsActions: bindActionCreators(ModalsActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExtendedMenuContainer);
